<template>
  <g>
    <g clip-path="url(#clip0_15_385)">
      <path
        d="M12.68 5.88025C13.38 5.64025 13.9 4.98025 13.98 4.24025C14.03 3.77025 13.93 3.33025 13.7 2.97025L12.42 0.750247C12.23 0.420247 11.75 0.420247 11.55 0.750247L10.27 2.97025C10.1 3.27025 10 3.62025 10 4.00025C10 5.32025 11.3 6.35025 12.68 5.88025ZM16.53 15.9202L15.53 14.9202L14.45 15.9902C13.15 17.2902 10.87 17.3002 9.56 15.9902L8.49 14.9202L7.4 15.9902C6.75 16.6402 5.88 17.0002 4.96 17.0002C4.23 17.0002 3.56 16.7702 3 16.3902V20.0002C3 21.1002 3.9 22.0002 5 22.0002H19C20.1 22.0002 21 21.1002 21 20.0002V16.3902C20.25 16.9002 19.29 17.1402 18.26 16.9102C17.6 16.7702 17.01 16.4002 16.53 15.9202ZM18 9.00025H13V8.00025C13 7.45025 12.55 7.00025 12 7.00025C11.45 7.00025 11 7.45025 11 8.00025V9.00025H6C4.34 9.00025 3 10.3402 3 12.0002V13.4602C3 14.3102 3.5 15.1302 4.31 15.4002C5.04 15.6402 5.83 15.4602 6.34 14.9402L8.48 12.8102L10.61 14.9402C11.37 15.7002 12.62 15.7002 13.38 14.9402L15.52 12.8102L17.65 14.9402C18.08 15.3702 18.68 15.5702 19.3 15.4902C20.29 15.3602 20.99 14.4302 20.99 13.4302V12.0102C21 10.3402 19.66 9.00025 18 9.00025Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_385">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
